﻿import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '../_services/authentication.service';
import { IdentityStorage } from '../_models/identity.storage';


@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private router: Router,
        private authService: AuthenticationService,
        private identify: IdentityStorage,

    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!this.authService.isAuthenticated()) {
            console.log('No Authentication Present, redirecting to Login');
            this.router.navigate(['login-externo']);
            return false;
        }

        this.authService.isExpired();
        const { perfil } = this.identify.getIdentity();

        const allowedRoles = route.data['roles'] as Array<string>;
        if (allowedRoles.includes(perfil)) {
            return true;
        }
        this.router.navigate(['login-externo']);
        return false;
    }
}
